// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import showDream from 'actions/dream/show';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import AddDreamModal from 'pages/Growth/GrowthPortfolio/components/Dreams/AddDreamModal/AddDreamModal';
import React, { useContext, useEffect } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import { GlobalRootDreamContext } from 'utilities/GlobalContext/GlobalRootDream';
import './Dreams.module.scss';
// =========================

const framerParent = {
  mount: { transition: { staggerChildren: 0.1 } },
};

const framerChild = {
  initial: { scale: 0, opacity: 0 },
  mount: { scale: 1, opacity: 1 },
};

export default function Dreams({
  displayDreamGrid,
}: {
  displayDreamGrid: boolean;
}) {
  // also change dreamsLength on growth portfolio if you change this one
  const dreams = useRedux((state) =>
    state.dream?.entities.allIds
      .map((id) => state.dream?.entities.byId[id])
      .filter((dream) => !dream?.is_public)
  );

  const translate = useTranslate();
  const { setRootDreamModal } = useContext(GlobalRootDreamContext);

  const { setModal } = useRootModal();

  const dispatch = useReduxAction();

  useEffect(() => {
    // Check if showDream has fired already for each dream in array
    if (dreams?.filter((d) => d?.contributed_projects).length) return;
    // map over all dreams and index them -> should be optimized!
    dreams?.forEach((dream) => dispatch(showDream(dream?.id)));
  }, []);

  return (
    <>
      <motion.div
        styleName={`wrapper ${displayDreamGrid ? 'grid' : ''}`}
        initial="initial"
        exit="initial"
        whileHover="whileHover"
        animate="mount"
        variants={framerParent}
      >
        {!!dreams?.length &&
          dreams.map(
            (dream, i) =>
              !!dream && (
                <motion.div
                  variants={framerChild}
                  styleName={`dream dream-${i + 1}`}
                  key={i}
                >
                  <ReflectionIcon
                    name={dream.name}
                    image={dream.image}
                    dream={dream}
                    preventDreamScale={displayDreamGrid}
                    onClick={() => setRootDreamModal({ dream, origin: 'view' })}
                  />
                </motion.div>
              )
          )}
        <motion.div
          variants={framerChild}
          onClick={() => setModal(<AddDreamModal />)}
          styleName="button-wrapper"
        >
          <motion.div {...interactiveScale} styleName="button">
            <FontAwesomeIcon icon={faPlus} />
            <p>{translate('dream.terms.new-dream')}</p>
          </motion.div>
        </motion.div>
      </motion.div>
      <RootReflectionModal type="dream" />
    </>
  );
}
